import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Notice } from '../../../../types/common.types';

import useTheme from '../../../../hooks/use-theme/useTheme';

import { removeSystemNotice } from '../../../../slices/system/system.slice';

import { ERROR, SUCCESS, WARNING } from '../../../../utils/constants';
import { getClassNames } from '../../../../utils/util';

import './system-notice.scss';

type Props = {
  notice: Notice;
};

const SystemNotice = ({ notice }: Props) => {
  const [entering, setEntering] = useState(true);
  const [leaving, setLeaving] = useState(false);

  const { pps } = useTheme();

  const dispatch = useDispatch();

  useEffect(() => {
    const enterTimeout = setTimeout(() => setEntering(false), 200);
    const leavingTimeout = setTimeout(() => setLeaving(true), 5000);

    return () => {
      clearTimeout(enterTimeout);
      clearTimeout(leavingTimeout);
    };
  }, []);

  useEffect(() => {
    if (!leaving) {
      return;
    }

    const timeout = setTimeout(() => dispatch(removeSystemNotice(notice.id)), 150);

    return () => clearTimeout(timeout);
  }, [dispatch, leaving, notice.id]);

  return (
    <div
      className={getClassNames('system-notice', {
        success: notice.type === SUCCESS,
        warning: notice.type === WARNING,
        error: notice.type === ERROR,
        entering,
        leaving,
        pps
      })}
      data-testid="system-notice"
    >
      <p>{notice.message}</p>
    </div>
  );
};

export default SystemNotice;
